import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { catchError, Observable } from 'rxjs'

import { environment } from '../../environments/environment'
import { RootInjectorGuard } from '../guards/root-injector.guard'
import { ErrorService } from './error.service'

@Injectable({
  providedIn: 'root',
})
export class ProductTagService extends RootInjectorGuard {
  private http = inject(HttpClient)
  private errorService = inject(ErrorService)

  private URL = environment.baseUrl + 'tags'

  constructor() {
    super(ProductTagService)
  }

  getByCompanyId(): Observable<Array<string>> {
    return this.http
      .get<Array<string>>(`${this.URL}`)
      .pipe(catchError(this.errorService.handleError))
  }
}
